"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.VatId = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Text2 = require("./Text");

var _validators = require("./validators");

var _nodeToolbox = require("@esnpm/node-toolbox");

var _inputs = require("./inputs");

var _Addressline = require("./Addressline");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translate = require("@esnpm/translate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VatId = exports.VatId = (_temp = _class = function (_Text) {
	_inherits(VatId, _Text);

	function VatId(props) {
		_classCallCheck(this, VatId);

		var _this = _possibleConstructorReturn(this, (VatId.__proto__ || Object.getPrototypeOf(VatId)).call(this, props));

		_this.vatIdValidator = _this.props.validators[0];
		// this.vatIdValidator = new ESValidator.VatIdPattern("DE");
		return _this;
	}

	_createClass(VatId, [{
		key: "componentWillMount",
		value: function componentWillMount() {
			_get(VatId.prototype.__proto__ || Object.getPrototypeOf(VatId.prototype), "componentWillMount", this).call(this);
			this.registerValidator(this.vatIdValidator);
		}
	}, {
		key: "setCountryCode",
		value: function setCountryCode(cc) {
			this.vatIdValidator.setPatternByCountryCode(cc);
			this.handleOnChange(this.state.value);
		}
	}, {
		key: "renderInput",
		value: function renderInput(props) {
			return _react2.default.createElement(_inputs.ESInput.CapitalText, props);
		}
	}]);

	return VatId;
}(_Text2.Text), _class.defaultProps = Object.assign({}, _Text2.Text.defaultProps, {
	fieldName: 'VATID',
	label: _react2.default.createElement(_translate.Tr, { path: 'esforms.fields.VAT_ID.label' }),
	trPlaceHolder: 'esforms.fields.VAT_ID.placeHolder',
	trHint: 'esforms.fields.VAT_ID.hint',
	allowedCharacters: "[A-Za-z0-9]",
	onRef: function onRef(r) {}
}), _class.propTypes = Object.assign({}, _Text2.Text.propTypes, {
	allowedCharacters: _propTypes2.default.string
}), _temp);